"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notification = require("./Notification");

Object.keys(_Notification).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Notification[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Notification[key];
    }
  });
});

var _ToastNotifacation = require("./ToastNotifacation");

Object.keys(_ToastNotifacation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ToastNotifacation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ToastNotifacation[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/notifications/index.js
// module id = 755
// module chunks = 0 15 16 17 18